// The 4 logo mediabank assets whose slug differs per locale. Single source of truth
// for both the Next app (page-head hreflang) and the `tsx`-run sitemap build, so this
// module uses only a local type — no `~/` alias import (the sitemap build resolves
// only relative imports). Paths are locale-prefix-less; consumers add the /no|/uk prefix.
export type Locale = 'en' | 'no' | 'uk'

export type MediabankLocaleSlugs = Partial<Record<Locale, string>>

export const MEDIABANK_ALTERNATES: MediabankLocaleSlugs[] = [
  {
    en: '/media/mediabank/house-of-math-icon-alt',
    no: '/media/mediabank/house-of-math-ikon-alt',
    uk: '/media/mediabank/alt-tekst-piktogrami-house-of-math',
  },
  {
    en: '/media/mediabank/house-of-math-logo-white',
    no: '/media/mediabank/house-of-math-logo-hvit',
    uk: '/media/mediabank/logotip-house-of-math-na-bilomu-tli',
  },
  {
    en: '/media/mediabank/house-of-math-icon',
    no: '/media/mediabank/house-of-math-ikon',
    uk: '/media/mediabank/piktograma-house-of-math',
  },
  {
    en: '/media/mediabank/house-of-math-logo-color',
    no: '/media/mediabank/house-of-math-logo-farge',
    uk: '/media/mediabank/kolir-logotipu-house-of-math',
  },
]

// The other-locale paths for the mediabank asset currently viewed, or {} when the
// slug isn't one of the tabled assets (→ no hreflang cluster).
export function mediabankLocalePaths(currentLocale: Locale, currentSlug: string): MediabankLocaleSlugs {
  const currentPath = `/media/mediabank/${currentSlug}`
  return MEDIABANK_ALTERNATES.find((row) => row[currentLocale] === currentPath) ?? {}
}
